import Uploader from './Uploader';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { nfn } from '../../common';
const Config = {
  axios,
  setConfig(axios) {
    this.axios = axios;
  }
};

Uploader.useUploadFile = ({
  url,
  onSuccess = nfn,
  onError = nfn,
  method = 'post'
}) => {
  const [file, setFile] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [percent, setPercent] = useState(0);

  const upload = params => {
    return Config.axios[method](url, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: progressEvent => {
        const percent =
          ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        setPercent(percent);
      }
    })
      .then(res => {
        onSuccess(res);
        setSuccess(true);
        setError(false);
      })
      .catch(err => {
        onError(err);
        setSuccess(false);
        setError(true);
      });
  };

  useEffect(() => {
    setSuccess(false);
    setError(false);
    setPercent(0);
  }, [file]);

  return {
    upload,
    percent,
    file,
    setFile,
    success,
    error
  };
};

Uploader.setConfig = Config.setConfig.bind(Config);

export default Uploader;
